import axios from 'axios';
import {ConstantsContainer} from "../helper/constants";

export const fetchPaymentTokenDetails = (token, accessToken) => {

    const fetchPaymentDetailsUrl = `${ConstantsContainer.hellopayBaseUrl}${ConstantsContainer.paymentTokenEndpoint}/${token}`

    return axios.get(fetchPaymentDetailsUrl, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Access-Control-Allow-Origin': '*',
            "Content-type": "application/json; charset=UTF-8",
            "Accept": "application/json; charset=UTF-8"
        },
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        })
}